import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { JobProcedureService } from "src/app/services/sections/job/job-procedure.service";
import { GlobalSettingsService } from "src/app/services/ui/global-settings.service";
import { ToastService } from "src/app/services/ui/toast.service";
import { ToastType } from "../toast/models/toast-type.enum";

@Component({
  selector: "procedure-summary-review-expired",
  templateUrl: "./procedure-summary-review-expired.component.html",
  styleUrls: [
    "./procedure-summary-review-expired.component.scss",
    "../job-details/job-details.component.scss",
    "../stylesheets/job-actions.scss",
    "../stylesheets/job-main.scss",
  ],
})
export class ProcedureSummaryReviewExpiredComponent implements OnInit {
  public isLinkRefreshLoading: boolean = false;
  public isLinkRefreshSuccess: boolean = false;
  public isLinkRefreshError: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private procedureService: JobProcedureService,
  ) {}

  ngOnInit(): void {
    this.refreshLink();
  }

  ngAfterViewInit(): void {
    GlobalSettingsService.isGlobalLoaderLoading = false;
    GlobalSettingsService.isSecondaryLoaderLoading = false;
  }

  public refreshLink(): void {
    this.isLinkRefreshLoading = true;
    this.procedureService.refreshProcedureSummaryReviewLink(this.route.snapshot.paramMap.get("token")!)
      .subscribe(
        () => {
          this.isLinkRefreshLoading = false;
          this.isLinkRefreshSuccess = true;
          ToastService.pushToast({
            text: 'A new confirmation link has been sent. Please check your email for the refreshed link.',
            icon: 'check_mark',
            type: ToastType.Success
          });
        },
        (error) => {
          this.isLinkRefreshLoading = false;
          this.isLinkRefreshError = true;
          console.error('Error refreshing procedure summary review link', error);
          ToastService.pushToast({
            text: 'Unable to refresh procedure summary review link. Please try again!',
            icon: 'error',
            type: ToastType.Error
          });
        }
      );
  }
}
